"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchicalNetGroup = void 0;
class HierarchicalNetGroup {
    constructor() {
        this.netsByInstance = new Map();
        this.dimensions = new Set();
        this.mutationVersion = 0;
        this.physicalName = '';
    }
    addNet(instance, net) {
        const existingNets = this.netsByInstance.get(instance);
        let added = false;
        if (existingNets) {
            if (!existingNets.includes(net)) {
                existingNets.push(net);
                added = true;
            }
        }
        else {
            this.netsByInstance.set(instance, [net]);
            added = true;
        }
        if (!added) {
            return;
        }
        this.mutationVersion++;
        for (const obj of net.netObjects) {
            for (const endpoint of obj.endpoints) {
                this.dimensions.add(endpoint.dimension);
            }
        }
    }
    contains(net) {
        for (const nets of this.netsByInstance.values()) {
            if (nets.includes(net)) {
                return true;
            }
        }
        return false;
    }
    containsNetName(netName) {
        for (const nets of this.netsByInstance.values()) {
            for (const net of nets) {
                if (net.name.valueOf() === netName) {
                    return true;
                }
            }
        }
        return false;
    }
    containsConnection(connection, inInstance) {
        for (const [instance, nets] of this.netsByInstance) {
            if (inInstance && instance !== inInstance) {
                continue;
            }
            for (const net of nets) {
                for (const conn of net.connections) {
                    if (connection.moduleRef && conn.connection.moduleRef !== connection.moduleRef) {
                        continue;
                    }
                    if (connection.pinRef && conn.connection.pinRef !== connection.pinRef) {
                        continue;
                    }
                    if (connection.moduleName && conn.connection.moduleName !== connection.moduleName) {
                        continue;
                    }
                    return true;
                }
            }
        }
        return false;
    }
    merge(instance, net) {
        if (!this.contains(net)) {
            this.addNet(instance, net);
        }
    }
    removeNet(instance, net) {
        const nets = this.netsByInstance.get(instance);
        if (nets === undefined) {
            return false;
        }
        const index = nets.indexOf(net);
        if (index === -1) {
            return false;
        }
        nets.splice(index, 1);
        if (nets.length === 0) {
            this.netsByInstance.delete(instance);
        }
        this.rebuildDimensions();
        this.mutationVersion++;
        return true;
    }
    getMutationVersion() {
        return this.mutationVersion;
    }
    isEmpty() {
        return this.netsByInstance.size === 0;
    }
    rebuildDimensions() {
        this.dimensions.clear();
        for (const nets of this.netsByInstance.values()) {
            for (const net of nets) {
                for (const obj of net.netObjects) {
                    for (const endpoint of obj.endpoints) {
                        this.dimensions.add(endpoint.dimension);
                    }
                }
            }
        }
    }
    getLocalNames() {
        const names = [];
        for (const nets of this.netsByInstance.values()) {
            for (const net of nets) {
                names.push(net.name.valueOf());
            }
        }
        return names;
    }
    getConnections(inInstance) {
        const connections = [];
        for (const [instance, nets] of this.netsByInstance) {
            if (inInstance && instance !== inInstance) {
                continue;
            }
            for (const net of nets) {
                for (const conn of net.connections) {
                    connections.push(conn.connection);
                }
            }
        }
        return connections;
    }
    getNetLabels(searchInInstance) {
        const labels = [];
        for (const [instance, nets] of this.netsByInstance) {
            if (searchInInstance && instance !== searchInInstance) {
                continue;
            }
            for (const net of nets) {
                for (const label of net.labels) {
                    labels.push(label);
                }
            }
        }
        return labels;
    }
    findNetForLabel(label) {
        for (const nets of this.netsByInstance.values()) {
            for (const net of nets) {
                if (net.labels.includes(label)) {
                    return net;
                }
            }
        }
        throw new Error('Label not found in group');
    }
    getNets() {
        return this.netsByInstance;
    }
    hasLabelType(labelType, searchInInstance) {
        for (const [instance, nets] of this.netsByInstance) {
            if (searchInInstance && instance !== searchInInstance) {
                continue;
            }
            for (const net of nets) {
                if (net.labels.some((label) => label.labelType === labelType)) {
                    return true;
                }
            }
        }
        return false;
    }
    hasObjectsOnDimension(dimension) {
        return this.dimensions.has(dimension);
    }
    hasObjectsOnDimensionMatching(predicate) {
        for (const dimension of this.dimensions) {
            if (predicate(dimension)) {
                return true;
            }
        }
        return false;
    }
}
exports.HierarchicalNetGroup = HierarchicalNetGroup;
//# sourceMappingURL=HierarchicalNetGroup.js.map